import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react'

import { SentMessageFilters } from '@/modules/log-of-all-messages/service/message-history-service.ts'

interface MessageHistoryFilterContextType {
  filter: SentMessageFilters
  setFilter: React.Dispatch<React.SetStateAction<SentMessageFilters>>
}

const MessageHistoryFilterContext = createContext<
  MessageHistoryFilterContextType | undefined
>(undefined)

export const MessageHistoryFilterProvider = ({
  children,
}: PropsWithChildren) => {
  const [filter, setFilter] = useState<SentMessageFilters>({})

  const value = { filter, setFilter }

  return (
    <MessageHistoryFilterContext.Provider value={value}>
      {children}
    </MessageHistoryFilterContext.Provider>
  )
}

export function useMessageHistoryFilter() {
  const context = useContext(MessageHistoryFilterContext)

  if (context === undefined) {
    throw new Error(
      'useMessageHistoryFilter must be used within a MessageHistoryFilterProvider',
    )
  }

  return context
}
